import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { servicesData } from '@/mocks/home';
import { getWhatsAppUrl, getGenericWhatsAppUrl } from '@/utils/whatsapp';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import JsonLd, { getWebPageSchema, getBreadcrumbSchema } from '@/utils/seo';
import CctvIcon from '@/components/base/CctvIcon';

const pvcBlindsService = {
  category: 'PVC and Bamboo Blinds',
  icon: 'ri-sun-line',
  items: ['PVC Blinds', 'Bamboo Blinds', 'Roller Blinds', 'Zebra Blinds', 'Venetian Blinds', 'Vertical Blinds', 'Motorized Blinds', 'Custom Blinds Installation'],
};

const amcService = servicesData.find(s => s.category === 'Annual Maintenance Contract (AMC)')!;
const servicesWithoutAMC = servicesData.filter(s => s.category !== 'Annual Maintenance Contract (AMC)');
const allServicesData = [...servicesWithoutAMC, pvcBlindsService, amcService];

const serviceSlugs = ['landscaping', 'upvc-windows', 'interior-works', 'wpc-paneling', 'branding', 'fabrication', 'electrical-plumbing', 'civil-waterproofing', 'deep-cleaning', 'flooring-wall-paneling', 'swimming-pool-fountain', 'cctv-surveillance', 'pvc-bamboo-blinds', 'amc'];
const serviceImages = [
  'https://readdy.ai/api/search-image?query=Indian%20luxury%20villa%20garden%20Bangalore%20with%20tropical%20landscaping%20coconut%20palms%20green%20lawn%20natural%20stone%20pathway%20colourful%20bougainvillea%20golden%20hour%20lighting%20professional%20outdoor%20photography&width=800&height=500&seq=svc-card-land&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Modern%20white%20UPVC%20sliding%20doors%20and%20casement%20windows%20in%20contemporary%20Indian%20home%20Bangalore%20bright%20natural%20light%20tropical%20garden%20view%20professional%20architectural%20photography&width=800&height=500&seq=svc-card-upvc&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Modern%20Indian%20luxury%20living%20room%20interior%20Bangalore%20with%20modular%20furniture%20elegant%20decor%20with%20Indian%20touches%20warm%20lighting%20premium%20apartment%20professional%20interior%20photography&width=800&height=500&seq=svc-card-int&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Modern%20Indian%20interior%20Bangalore%20with%20elegant%20wooden%20WPC%20wall%20panelling%20and%20premium%20flooring%20warm%20tones%20contemporary%20residential%20design%20professional%20photography&width=800&height=500&seq=svc-card-wpc&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Modern%20illuminated%203D%20sign%20board%20on%20Indian%20shopfront%20Bangalore%20led%20lit%20letters%20premium%20retail%20exterior%20warm%20evening%20light%20professional%20commercial%20photography&width=800&height=500&seq=svc-card-brand&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Stainless%20steel%20railing%20and%20metal%20fabrication%20work%20in%20modern%20Indian%20staircase%20Bangalore%20glass%20panels%20premium%20residential%20interior%20polished%20metal%20professional%20photography&width=800&height=500&seq=svc-card-fab&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Indian%20professional%20electrician%20working%20on%20modern%20electrical%20panel%20installation%20Bangalore%20bright%20clean%20workspace%20tools%20organised%20professional%20service%20photography&width=800&height=500&seq=svc-card-elec&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Indian%20construction%20workers%20applying%20waterproofing%20membrane%20on%20Bangalore%20building%20terrace%20professional%20civil%20engineering%20team%20safety%20equipment%20modern%20building%20photography&width=800&height=500&seq=svc-card-civil&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Indian%20professional%20deep%20cleaning%20team%20in%20uniform%20cleaning%20modern%20Bangalore%20home%20with%20steam%20cleaners%20and%20equipment%20spotless%20clean%20interior%20bright%20photography&width=800&height=500&seq=svc-card-clean&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Luxury%20Indian%20villa%20living%20room%20Bangalore%20with%20rich%20warm%20SPC%20wooden%20flooring%20wide%20plank%20format%20an%20elegant%20WPC%20decorative%20wall%20panel%20accent%20wall%20modern%20sofa%20natural%20daylight%20streaming%20through%20large%20windows%20warm%20premium%20interior%20professional%20photography&width=800&height=500&seq=svc-card-flooring&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Stunning%20luxury%20Indian%20villa%20infinity%20swimming%20pool%20Bangalore%20crystal%20turquoise%20water%20vanishing%20edge%20submerged%20LED%20lights%20tropical%20garden%20surrounds%20palm%20trees%20sunset%20golden%20hour%20glow%20upscale%20residential%20professional%20architectural%20photography&width=800&height=500&seq=svc-card-pool&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Modern%20professional%20CCTV%20surveillance%20security%20camera%20system%20installation%20in%20Bangalore%20commercial%20building%20with%20monitoring%20setup%20night%20vision%20dome%20cameras%20control%20room%20digital%20screens%20professional%20security%20technology%20photography&width=800&height=500&seq=svc-card-cctv&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Premium%20stylish%20PVC%20and%20bamboo%20blinds%20installed%20in%20a%20bright%20modern%20luxury%20Indian%20living%20room%20Bangalore%20with%20warm%20natural%20sunlight%20softly%20filtering%20through%20elegant%20layered%20window%20coverings%20contemporary%20sofa%20and%20wooden%20coffee%20table%20cozy%20sophisticated%20interior%20atmosphere%20professional%20interior%20design%20photography&width=800&height=500&seq=svc-card-blinds&orientation=landscape&nocache=true',
  'https://readdy.ai/api/search-image?query=Indian%20professional%20maintenance%20technician%20inspecting%20building%20systems%20clipboard%20in%20hand%20modern%20Bangalore%20commercial%20facility%20professional%20service%20photography&width=800&height=500&seq=svc-card-amc&orientation=landscape&nocache=true',
];

const hasDetailPage = (slug: string) => ['landscaping', 'interior-works', 'upvc-windows', 'civil-waterproofing', 'deep-cleaning', 'flooring-wall-paneling', 'swimming-pool-fountain'].includes(slug);

export default function ServicesPage() {
  const { ref: gridRef, isVisible } = useScrollAnimation(0.03);

  return (
    <Layout>
      <JsonLd data={getWebPageSchema('Our Services | Complete Property Solutions in Bangalore', 'Comprehensive property solutions in Bangalore — Landscaping Interiors UPVC Windows Flooring Branding Fabrication Civil Works Deep Cleaning AMC and more all under one roof.', 'https://infiniteconsultant.com/services')} />
      <JsonLd data={getBreadcrumbSchema([{ name: 'Home', url: 'https://infiniteconsultant.com/' }, { name: 'Services', url: 'https://infiniteconsultant.com/services' }])} />
      {/* Hero */}
      <section className="relative h-[350px] md:h-[450px] w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20diverse%20Indian%20construction%20and%20property%20services%20collage%20Bangalore%20featuring%20landscaping%20interior%20design%20windows%20fabrication%20cleaning%20and%20maintenance%20works%20professional%20Indian%20service%20industry%20photography&width=1600&height=800&seq=services-hero&orientation=landscape&nocache=true"
          alt="Our Services"
          className="absolute inset-0 w-full h-full object-cover object-top animate-reveal"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70" />
        <div className="absolute inset-0 flex items-end">
          <div className="w-full px-4 sm:px-6 lg:px-10 pb-10 md:pb-14">
            <div className="max-w-6xl mx-auto">
              <nav className="flex items-center gap-2 text-white/80 text-sm mb-4" aria-label="Breadcrumb">
                <Link to="/" className="hover:text-white transition-colors whitespace-nowrap cursor-pointer">Home</Link>
                <span className="text-white/50">/</span>
                <span className="text-white whitespace-nowrap">Services</span>
              </nav>
              <h1 className="font-heading font-bold text-2xl md:text-4xl lg:text-5xl text-white mb-3" style={{ opacity: 0, animation: 'fadeUpSoft 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.1s forwards' }}>
                Our Services
              </h1>
              <p className="text-sm md:text-lg text-white/80 max-w-2xl" style={{ opacity: 0, animation: 'fadeUpSoft 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.25s forwards' }}>
                Comprehensive property solutions — from design to maintenance, all under one roof.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* All Services Grid */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 sm:px-6 lg:px-10">
          <div ref={gridRef} className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {allServicesData.map((service, index) => {
                const slug = serviceSlugs[index];
                const detailPage = hasDetailPage(slug);
                const isAMC = slug === 'amc';

                return (
                  <div
                    key={index}
                    id={slug === 'cctv-surveillance' ? 'cctv-surveillance' : slug === 'pvc-bamboo-blinds' ? 'pvc-bamboo-blinds' : slug === 'amc' ? 'amc' : undefined}
                    className={`bg-white rounded-xl border border-background-200/70 overflow-hidden hover:shadow-sm transition-all duration-500 group scroll-mt-24 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                    style={{ transitionDelay: `${index * 0.08}s` }}
                  >
                    <div className="relative h-48 md:h-56 overflow-hidden">
                      <img
                        src={serviceImages[index]}
                        alt={service.category}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent" />
                      <div className="absolute top-4 left-4 w-10 h-10 rounded-lg bg-white/90 backdrop-blur-sm flex items-center justify-center">
                        {service.category === 'CCTV Surveillance' ? (
                          <CctvIcon className="w-5 h-5 text-primary-500" />
                        ) : (
                          <i className={`${service.icon} text-primary-500 text-lg`} />
                        )}
                      </div>
                    </div>

                    <div className="p-5 md:p-6">
                      <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-3">
                        {service.category}
                      </h3>

                      {isAMC && (
                        <div className="mb-4 p-3 rounded-lg bg-accent-50 border border-accent-200/60">
                          <p className="text-sm font-semibold text-accent-800 mb-1">AMC Available for All Our Services</p>
                          <p className="text-xs text-foreground-600 leading-relaxed">
                            Our Annual Maintenance Contract (AMC) is available for all services offered by Infinite Consultant & Services, ensuring regular maintenance, preventive inspections, and long-term performance.
                          </p>
                        </div>
                      )}

                      <div className="flex flex-wrap gap-2 mb-5">
                        {service.items.map((item, idx) => (
                          <span
                            key={idx}
                            className="inline-block px-2.5 py-1 rounded-md text-xs font-medium bg-background-100 text-foreground-600 border border-background-200/50"
                          >
                            {item}
                          </span>
                        ))}
                      </div>

                      <div className="flex items-center gap-2">
                        {detailPage ? (
                          <>
                            <Link
                              to={`/services/${slug}`}
                              className="flex-1 px-4 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              Learn More
                              <div className="w-3 h-3 inline-flex items-center justify-center ml-1">
                                <i className="ri-arrow-right-line text-xs" />
                              </div>
                            </Link>
                            <a
                              href={getWhatsAppUrl(service.category)}
                              target="_blank"
                              rel="nofollow noopener noreferrer"
                              className="px-4 py-2.5 rounded-lg bg-secondary-50 text-secondary-600 text-sm font-medium hover:bg-secondary-100 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              <i className="ri-whatsapp-line mr-1" />
                              Enquire
                            </a>
                          </>
                        ) : (
                          <>
                            <span className="flex-1 px-4 py-2.5 rounded-lg bg-background-100 text-foreground-500 text-sm font-medium text-center whitespace-nowrap cursor-default">
                              Available
                            </span>
                            <a
                              href={getWhatsAppUrl(service.category)}
                              target="_blank"
                              rel="nofollow noopener noreferrer"
                              className="px-4 py-2.5 rounded-lg bg-secondary-50 text-secondary-600 text-sm font-medium hover:bg-secondary-100 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              <i className="ri-whatsapp-line mr-1" />
                              {service.category === 'CCTV Surveillance' ? 'Get Quote' : 'Enquire'}
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-gradient-brand">
        <div className="w-full px-4 sm:px-6 lg:px-10">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-white mb-4">
              Not Sure Which Service You Need?
            </h2>
            <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto mb-8">
              Our experts can assess your requirements and recommend the right solution. Get in touch for a free consultation.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/contact"
                className="btn-ripple w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white text-primary-600 font-semibold text-sm hover:bg-background-50 transition-all duration-300 hover:scale-[1.03] whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </Link>
              <a
                href={getGenericWhatsAppUrl()}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/10 text-white border border-white/20 font-medium text-sm hover:bg-white/20 transition-all duration-300 hover:scale-[1.03] whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2" />
                WhatsApp Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}